export default class CountryService {
  static getSubdivisions = (countryCode) =>
    fetch(`/tickets/countries/${countryCode}/subdivisions`)
      .then(response => response.json());
}
